function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronRight = function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8 18"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M.46 18c-.1 0-.2 0-.3-.1-.2-.19-.2-.39-.1-.58l6.96-8.29L.16.74C-.03.55.07.26.26.06c.2-.1.4-.1.6.1l7.06 8.58c.1.19.1.39 0 .58L.86 17.9c-.1 0-.2.1-.4.1",
    style: {
      strokeWidth: 0
    }
  }));
};
export default SvgChevronRight;